/* 🤖 this file was generated by svg-to-ts */
export const matIconCallMerge: {
  name: 'call-merge';
  data: string;
} = {
  name: 'call-merge',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 20.41 18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"/></svg>`
};
